import { IDatiqMcQueryParams } from '@dat/datiq-mc/utils';
import { z } from 'zod';

export interface IIqMcInfoBadge {
    queryParams?: IDatiqMcQueryParams;
    message: string;
    showInfoIcon: boolean;
}

export const McLocationQueryTypeSchema = z.union([
    z.literal('location'),
    z.literal('area'),
]);

export enum Directions {
    InBound = 'IN',
    OutBound = 'OUT',
}

const DirectionSchema = z.nativeEnum(Directions);

export enum GeoTypes {
    Country = 'COUNTRY',
    Region = 'REGION',
    State = 'STATE',
    ExtendedMarket = 'X_MKT',
    Market = 'MKT',
    ThreeDZ = 'THREEDZ',
}

const GeoTypesSchema = z.nativeEnum(GeoTypes);

export enum EquipmentTypes {
    Van = 'VAN',
    Reefer = 'REEFER',
    FlatBed = 'FLATBED',
}

export const EquipmentTypeSchema = z.union([
    z.nativeEnum(EquipmentTypes),
    z.literal(''),
]);

export enum TimeFrames {
    ThirtyDaysBack = 'THIRTY_DAYS_BACK',
    EightDaysBack = 'EIGHT_DAYS_BACK',
    PrevBusinessDay = 'PREV_BUSINESS_DAY',
    Current = 'CURRENT',
    EightDayForecast = 'EIGHT_DAY_FORECAST',
}

const TimeFrameSchema = z.nativeEnum(TimeFrames);

export const McQuerySchema = z.object({
    id: z.string(),
    type: McLocationQueryTypeSchema,
    direction: DirectionSchema,
    geoType: GeoTypesSchema,
    geoCode: z.string().default(''),
    equipmentType: EquipmentTypeSchema,
    timeframe: TimeFrameSchema.default(TimeFrames.Current),
    displayName: z.string().or(z.null()).default(''),
    date: z.string().or(z.null()).default(''),
});

export type McQuery = z.infer<typeof McQuerySchema>;
